module.exports = __webpack_public_path__ + "img/brand-cases22.d8728c53.png";